<style lang="sass" scoped>
  @import '../../../sass/variables'

  .card
    height: 471px

    .card-header
      font-weight: 700
      color: $salesflow-font-gray
      font-size: 1.5rem
      line-height: 120%

    tr
      background-color: $salesflow-bg-content

      .stat-name
        font-weight: 500
        font-size: 1rem
        line-height: 125%
        color: $salesflow-font-dark

  .badge
    font-size: 0.875rem
    line-height: 1.05rem
    font-weight: 500
    border-radius: 100px
    padding: 4px 10px

    &.badge-default
      background-color: $salesflow-bg-body
      color: $salesflow-font-dark

    &.badge-danger
      color: white
      background-color: $salesflow-danger
</style>

<template>
  <div class="card card-table with-shadow">
    <div class="card-header">
      <h2 class="float-left">
        {{ __('Stats') }}
      </h2><i
        class="fa fa-circle-o-notch fa-spin float-right"
        v-show="loading"
      />
    </div>
    <div class="card-body">
      <DashboardEmptyData
        class="dashboard-empty-data"
        :content="__('Adicione leads para começar.')"
        v-if="!data.length"
      />
      <table
        v-if="data.length"
        class="table"
        v-show="!loading"
      >
        <tbody>
          <tr
            v-for="stat in data"
            :key="stat.name"
          >
            <td class="stat-name align-middle">
              <a
                :href="stat.url"
                target="_blank"
              >{{ __(stat.name) }}</a>
            </td>
            <td class="align-middle text-right">
              <span
                class="badge"
                :class="{ 'badge-danger': stat.danger && stat.total > 0, 'badge-default': !stat.danger || stat.total == 0 }"
              ><span v-if="stat.total">{{ stat.total | number(0) }}</span><span v-else>-</span></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Widget from '../../mixins/widget';

export default {
  props: ['user'],

  mixins: [Widget],

  data () {
    return {
      name: 'lead.stats',
      loading: true,
      error: false,
      data: {},
    };
  },
};
</script>
